export const CSS_CLASSES = {
  OVERLAY_ROOT: "overlay",
  OVERLAY_BACKDROP: "overlay-backdrop",
  OVERLAY_CLIP_CONTAINER: "overlay-clip-container",
  OVERLAY_SCROLL_CONTAINER: "overlay-scroll-container",
  OVERLAY_CONTENT: "overlay-content",
  OVERLAY_INLINE: "overlay-inline",
  OVERLAY_OPEN: "overlay-open",
};
